
import {defineComponent, PropType } from 'vue'
import {isUUID} from '@/utils'
import { useStore } from 'vuex'
import { CtPacking, CtSupplierCatalogue } from '@/models/interfaces/content-type'
import SupplierCatalogueSettings from '@/pages/WIP/components/SupplierCatalogueSettings.vue'
import SupplierCatalogueSyncSettings from '@/pages/WIP/components/SupplierCatalogueSyncSettings.vue'
import TrashIcon from '@/components/Icons/TrashIcon.vue'
import DButton from '@/components/base/DButton.vue'
import SupplierCatalogueStockItems from '@/pages/WIP/components/SupplierCatalogueStockItems.vue'
import SupplierCatalogueRecentOrders from './SupplierCatalogueRecentOrders.vue'

import Directr, { ContentType } from '@/services/directr'

interface CombinedProducts {
  supplier_catalogue_id: string,
  active: boolean,
}

interface ProductState {
  curr: CombinedProducts[],
  prev: CombinedProducts[],
}

export default defineComponent({
  name: 'SupplierCatalogueDetails',
  props: {
    supplierCatalogue: {
      type: Object as PropType<CtSupplierCatalogue>,
      required: true,
    },
    activeToggle: {
      type: Boolean,
      default: false,
    },
    packing: {
      type: Array as PropType<Array<CtPacking>>
    }
  },
  components: {
    TrashIcon,
    SupplierCatalogueSettings,
    SupplierCatalogueSyncSettings,
    DButton,
    SupplierCatalogueStockItems,
    SupplierCatalogueRecentOrders
  },
  emits: ['packing-resolved', 'save:catalogue', 'delete', 'update:supplier-catalogue'],
  setup (props, { emit }) {
    const $store = useStore()
    const $directr: Directr = $store.getters['Services/Directr']

    async function updateSupplierToken(supplier, token) {
      return $directr.patch(ContentType.Supplier, isUUID(supplier) ? supplier : supplier.sys.id, token ).then(({items}) => items?.[0])
    }

    async function handleUpdateSupplierCatalogue (supCatId, payload) {
      try {
        if (payload.token) {
          const supplier = await updateSupplierToken(supCatId, payload.token)
          delete payload.token
          payload.supplier = supplier
        }
      } catch (e) {
        console.error('Error handling supplier token update', e)
      }

      emit('update:supplier-catalogue', supCatId, payload)
    }

    return {
      handleUpdateSupplierCatalogue
    }
  }
})
